import { useConfirmationDialog } from "../../../components/Dialogs/confirmation-dialog";

interface HidePricesToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export function HidePricesToggle({
  checked,
  onChange,
  disabled,
  className,
}: HidePricesToggleProps) {
  const { component: confirmDialog, open: openConfirm } = useConfirmationDialog(
    "Are you sure you want to hide prices for this customer?\n\nThey will not see any prices on the platform and the cart will be disabled. You can re-enable this at any time.",
    () => onChange(true),
  );

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.checked) {
      openConfirm();
    } else {
      onChange(false);
    }
  }

  return (
    <div className={className ?? "my-4 flex flex-col space-y-1 border-t pt-4"}>
      <label className="flex items-center space-x-2 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className="h-4 w-4"
        />
        <span className="font-bold text-sm">
          Hide prices from this customer
        </span>
      </label>
      <p className="text-xs text-gray-500 ml-6">
        The customer can only create and build logos and designs. All prices,
        the cart, ordering and order details are hidden.
      </p>
      {confirmDialog}
    </div>
  );
}
